module.exports = __webpack_public_path__ + "static/media/sre-downhole.90007da8.svg";